import { LoadingOutlined } from '@ant-design/icons'
import { Company } from '@models/business/Company'
import { fetchRollingDays } from '@services/business/CompanyService'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { currencyFormat } from '@utils/currencyFormatter'
import { Spin, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { selectCompanyById } from '../../../store/business/CompanyReducer'
import { useAppSelector } from '../../../store/hooks'

const { Text } = Typography

type Props = SBModelComponent<Company> & {}

export const CompanyRollingDays = ({ id, model }: Props) => {
  const item = model ? model : useAppSelector(selectCompanyById(id!))
  const [rollingDays, setRollingDays] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    if (!item) return
    setIsLoading(true)

    fetchRollingDays(item.id)
      .then((data) => {
        setRollingDays(data.data)
      })
      .finally(() => setIsLoading(false))
  }, [item])

  if (!item) {
    return <></>
  }

  return (
    <>
      {isLoading ? (
        <Spin indicator={<LoadingOutlined spin />} />
      ) : (
        <Text>{currencyFormat(rollingDays, true)}</Text>
      )}
    </>
  )
}

export type CompanyRollingDaysType = { RollingDays: typeof CompanyRollingDays }
